import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Plugins, StatusBarStyle } from '@capacitor/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar as NgxStatusBar } from '@ionic-native/status-bar/ngx';
import { NavController, Platform } from '@ionic/angular';
import { AuthenticationFacade } from '@symphony-solo/domain/authentication/src';
import { CompanyConfigFacade } from '@symphony-solo/domain/company-config/src';
import { OrderFacade } from '@symphony-solo/domain/order/src';
import { AppBaseComponent } from '@symphony-solo/shared/app-base/src';
const { StatusBar } = Plugins;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent extends AppBaseComponent {
  public isMenuReset: boolean;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: NgxStatusBar,
    protected orderFacade: OrderFacade,
    protected authenticationFacade: AuthenticationFacade,
    protected companyConfigFacade: CompanyConfigFacade,
    protected navController: NavController,
    protected router: Router
  ) {
    super(companyConfigFacade, authenticationFacade, orderFacade, navController, router);
    this.initializeApp();
  }

  protected async initializeApp() {
    await super.initializeApp();
    this.platform.ready().then(() => {
      if (this.platform.is('capacitor')) {
        StatusBar.setStyle({
          style: StatusBarStyle.Light,
        });
        StatusBar.setBackgroundColor({
          color: '#ffffff',
        });
      } else {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      }
    });
  }

  public resetMenu() {
    this.isMenuReset = !this.isMenuReset;
  }
}